import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { pluralize } from 'utils'

export function showSuccessfulCopyToast(fileCount: number, url: string, selectedFolderName: string | null | undefined) {
  const message = () => {
    if (selectedFolderName) {
      return (
        <span>
          <b>{fileCount}</b> {pluralize('item', fileCount)} copied to <b>{selectedFolderName}</b>!
        </span>
      )
    } else {
      return (
        <span>
          <b>{fileCount}</b> {pluralize('folder', fileCount)} {fileCount > 1 ? 'have' : 'has'} been copied to the top
          level folder!
        </span>
      )
    }
  }

  showToastMessage(
    <span>{message()}</span>,
    'success',
    { variant: 'proceed', type: 'link', to: url, label: 'Go to Project' },
    2.5,
  )
}
